export default {
  filterData : {
    Products: {
      label: 'Ürünler',
      allFilterLabel: "Tüm Ürünler",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Konular",
      allFilterLabel: "Tüm konular",
      items: [
        { name: "Erişim yönetimi", id: "Access management" },
        { name: "Analiz ve izleme", id: "Analytics and monitoring" },
        { name: "Uygulama dağıtımı ve güvenliği", id: "Application delivery and security" },
        { name: "Citrix ve Google", id: "Citrix and Google" },
        { name: "Citrix ve Microsoft", id: "Citrix and Microsoft" },
        { name: "Buluta geçiş", id: "Cloud migration" },
        { name: "Karşılaştırın", id: "Compare" },
        { name: "İçerik iş birliği", id: "Content collaboration" },
        { name: "Dijital çalışma alanları", id: "Digital workspaces" },
        { name: "Çalışan deneyimi", id: "Employee experience" },
        { name: "Karma bulut", id: "Hybrid cloud" },
        { name: "Karma çalışma", id: "Hybrid work" },
        { name: "Yönetin ve optimize edin", id: "Manage and optimize" },
        { name: "Mikro hizmetler ve devOps", id: "Microservices and devOps" },
        { name: "Uygulama ve benimseme", id: "Onboarding and adoption" },
        { name: "İş ortağı entegrasyonları", id: "Partner integrations" },
        { name: "Ürüne genel bakış", id: "Product overview" },
        { name: "Güvenlik ve uyumluluk", id: "Security and compliance" },
        { name: "Küçük işletmeler", id: "Small business" },
        { name: "Teknik özellikler", id: "Specifications" },
        { name: "Sürdürülebilirlik", id: "Sustainability" },
        { name: "Birleştirilmiş uç nokta yönetimi", id: "Unified endpoint management" },
        { name: "VDI ve DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Tür',
      allFilterLabel: "Tüm Türler",
      items: [
        { name: "Analist raporu", id: "Analyst report" },
        { name: "Değerlendirme aracı", id: "Assessment tool" },
        { name: "Müşteri hikayesi", id: "Customer story" },
        { name: "Veri sayfası", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "E-Kitap", id: "eBook" },
        { name: "Rehberlik Edin", id: "Guide" },
        { name: "Bilgi görseli", id: "Infographic" },
        { name: "İnteraktif tur", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Kaynak kiti", id: "Resource kit" },
        { name: "Çözüm özeti", id: "Solution brief" },
        { name: "Teknik özet", id: "Technical brief" },
        { name: "Video", id: "Video" },
        { name: "Web Semineri", id: "Webinar" },
        { name: "Tanıtım yazısı", id: "White paper" },
      ],
    },
    Industry: {
      label: "Sektör",
      allFilterLabel: "Tüm Endüstriler",
      items: [
        { name: "Eğitim", id: "education" },
        { name: "Finansal Hizmet", id: "financial_service" },
        { name: "Kamu", id: "government" },
        { name: "Sağlık", id: "healthcare" },
        { name: "İmalat", id: "manufacturing" },
        { name: "Perakende", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Kütüphanede Ara",
    titles : {
      label1: "Şu anki trendler",
      label2: "En yeni kaynaklar",
      label3: "Son görüntülenenler",
      label4: "Önerilen kaynaklar"
    },
    showMoreLabel: "Daha fazlasını göster",
    clearAllSelected: "Tüm Seçilenleri Temizle",
    searchResults: "Şununla ilgili arama sonuçları:",
    clearAllFilters: "Tüm filtreleri temizle",
    noResultsFound: "Seçtiğiniz kriterleri karşılayan hiçbir ürün yok",
    resetView: "Görünümü sıfırla",
    filterLabel: "Filtre",
    filteredRes: "Filtrelenmiş sonuçlar",
    filterRes: "Sonuçlarınızı filtreleyin",
    clearAllCta: "Tümünü temizle",
    applyCta: "Uygula",
    view: "Görüntüleyin",
    includeEnglishRes: "İngilizce kaynakları dahil et"
  };
  